module.exports = __webpack_public_path__ + "img/tottenham1.befc066d.jpg";